import { CopyToClipboard } from 'react-copy-to-clipboard';

// Files in the same folder
import { ReactComponent as SVGCopyIcon } from './assets/icons/icon-copy.svg';
// Types
import { LanguageFlagsData } from './TrackingCodeContainer';
// Utils
import { TORFX, TORFX_OZ } from "../../core/utils/Constants/Constants";

export type LinkType = 'client' | 'partner' | 'directSignUp';

interface TrackingCodeSectionProps {
    header: string;
    linkType: LinkType;
    data: LanguageFlagsData[];
    componentData: any;
    affiliateNumber: string;
    classes: any;
    translate: Function;
    onCopySuccess: () => void;
    flagComponents: (item: LanguageFlagsData) => JSX.Element;
}

export const TrackingCodeSection: React.FC<TrackingCodeSectionProps> = ({
    header,
    linkType,
    data,
    componentData,
    affiliateNumber,
    classes,
    translate,
    onCopySuccess,
    flagComponents
}) => {
    const buildUrl = (item: LanguageFlagsData): string => {
        const isPartner: boolean = linkType === 'partner';
        const organizationWisePath: string = isPartner
            ? ''
            : (componentData.orgCode === TORFX || componentData.orgCode === TORFX_OZ
                ? '/affiliate/quote'
                : `/${item.lang}`);
        const linkTypePath: string = isPartner ? '/refer-a-partner' : '';
        const queryStringKey: string = isPartner ? 'RefPartner' : 'afflno';
        const clientPartnerUrl: string = `${componentData.orgUrl}${organizationWisePath}${linkTypePath}/?${queryStringKey}=${affiliateNumber}`;

        const registerPath: string = 'register';
        const directSignUpUrl: string = `${componentData.portalUrl}/${registerPath}/?RefPartner=${affiliateNumber}`;

        return linkType === 'directSignUp' ? directSignUpUrl : clientPartnerUrl;
    };

    return (
        <>
            <h2>{header}</h2>
            <div className={classes.trackingCodeItemContainer}>
                {data.map((item: LanguageFlagsData, index: number) => {
                    const finalUrl = buildUrl(item);
                    const flagName = flagComponents(item);

                    return (
                        <CopyToClipboard
                            key={`code-${index}`}
                            text={finalUrl}
                            onCopy={onCopySuccess}
                        >
                            <div className={classes.trackingCodeItem}>
                                {flagName}
                                <div>{finalUrl}</div>
                                <span>
                                    <SVGCopyIcon /> {translate('trackingCode.copycode.link')}
                                </span>
                            </div>
                        </CopyToClipboard>
                    );
                })}
            </div>
        </>
    );
};